<script setup lang="ts">
import { FieldSelect } from '@magma-app/magma-lapilli';

import type {
  HelperCampaignCriteriaViewModel,
  HelperCriteriaAnswers,
  HelperSelectOption,
} from '../types';

defineProps<{
  criteria: HelperCampaignCriteriaViewModel[];
  answers: HelperCriteriaAnswers;
  getOptions: (criteriaId: number) => HelperSelectOption[];
}>();
</script>

<template>
  <div>
    <FieldSelect
      v-for="campaignCriteriaItem in criteria"
      :id="campaignCriteriaItem.criteriaId"
      :key="campaignCriteriaItem.criteriaId"
      v-model="answers[campaignCriteriaItem.criteriaId]"
      class="mt-4"
      :label="campaignCriteriaItem.labelHelper"
      :options="getOptions(campaignCriteriaItem.criteriaId)"
      :multiple="campaignCriteriaItem.type === 'multiSelect'"
      :required="true"
      data-cy="criteria"
    />
  </div>
</template>
